// Copyright 2025-2026 - Hewlett Packard Enterprise Company
import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, ResponsiveContext } from 'grommet';
import ChatHeader from './ChatHeader';
import ChatFooter from './ChatFooter';
import ChatMainContent from './ChatMainContent';
import ChatInsightsContent from './ChatInsightsContent';
import { SidebarContext } from '../../providers/SidebarProvider';

export default function ChatContainer({ onClose }) {
  const size = useContext(ResponsiveContext);
  const { insightsTriggered, insightsMode, setInsightsMode } =
    useContext(SidebarContext);

  // Enter insights mode when triggered
  useEffect(() => {
    if (insightsTriggered) {
      setInsightsMode(true);
    }
  }, [insightsTriggered, setInsightsMode]);

  return (
    <Box data-testid="chatContainerBox" height="100vh">
      <Box
        fill="vertical"
        gap="none"
        width={{
          min: !['xsmall', 'small'].includes(size) ? 'medium' : undefined,
        }}
      >
        <ChatHeader onClose={onClose} />
        {insightsMode ? <ChatInsightsContent /> : <ChatMainContent />}
      </Box>
      <ChatFooter />
    </Box>
  );
}

ChatContainer.propTypes = {
  onClose: PropTypes.func.isRequired,
};
